import { useCallback, useEffect, useRef, useState } from 'react'

export function useRemainingsTime(serverTime: string, activationDate: string) {
  const serverNow = new Date(serverTime).getTime()
  const perfSnapshot = useRef(performance.now()) // ← фиксируем один раз
  const expiresAt = new Date(activationDate).getTime() + 60 * 60 * 1000

  const getRemainingMs = useCallback(() => {
    const elapsed = performance.now() - perfSnapshot.current
    const realNow = serverNow + elapsed

    return expiresAt - realNow
  }, [expiresAt, serverNow])

  const [remaining, setRemaining] = useState(getRemainingMs)

  useEffect(() => {
    const interval = setInterval(() => {
      const ms = getRemainingMs()

      setRemaining(ms)
      if (ms <= 0) clearInterval(interval)
    }, 1000)

    return () => clearInterval(interval)
  }, [getRemainingMs])

  return Math.max(0, Math.floor(remaining / 1000 / 60)) // минуты
}
